export default "__VITE_ASSET__3388f7f1__"